<template>
  <div :class="['home flex-column', programStyle]">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('user-lookup') }}</span>
      </div>
      <div class="right" v-if="appliedFilters">
        <FilterModal
          :appliedFiltersLength="appliedFilters.length"
          :valueMulti="activeFilters"
          @clear-filters="clearAllFilters"
          @updateMulti="updateMulti"
        />
        <div>
          <Magnifier class="search-icn"></Magnifier>
          <input
            class="search-input"
            :placeholder="$t('search')"
            v-model="search"
            type="text"
            v-debounce:1000ms="searchDebounce"
          />
        </div>
      </div>
    </div>
    <span class="last-updated" v-if="lastUpdated"> Last Updated: {{ lastUpdated | calendarDate }} EST </span>
    <div v-if="users" class="flex-column">
      <div class="flex-column">
        <DataTable :headings="userLookupTH" :rows="users" :perPage="numPerPage">
          <template v-slot:viewSlot="slotProps">
            <Eyecon class="eyecon" @click="view(slotProps)"></Eyecon>
          </template>
          <template v-slot:periSlot="slotProps">
            <span v-if="slotProps.row.configName">{{ slotProps.row.configName }}</span>
            <span v-else>{{ slotProps.row.period }}</span>
          </template>
        </DataTable>
        <div class="row-container" v-if="users">
          <div class="row-info">
            {{ $t('viewing-firstrow-lastrow-of-forms-totalcount', [firstRow, lastRow, totalCount]) }}
          </div>
          <GPagination
            v-if="pageCount > 1"
            class="pagination"
            v-model="page"
            :pageCount="pageCount"
            @changed="getLookupDataWithLoad"
          />
          <div class="placeholder-div"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Eyecon from '@/assets/new/eye-con.svg';
import GPagination from '@/components/GComponents/GPagination.vue';
import Magnifier from '@/assets/icons/magnifier.svg';
import { mapState } from 'vuex';
import userLookupTH from '@/utils/tableHeaders/userLookupTH';
import FilterModal from '@/components/FilterModal.vue';

export default {
  name: 'UserLookup',
  components: {
    DataTable,
    Eyecon,
    GPagination,
    Magnifier,
    FilterModal,
  },
  data() {
    return {
      numPerPage: 15,
      search: '',
      page: 1,
      rowCountDropValue: { label: this.$t('show-10'), value: 15 },
      users: null,
      totalCount: null,
      userLookupTH: userLookupTH(),
      loader: this.$loading.show(),
      roleFilter: [],
      domainFilter: [],
      serviceDistrictFilter: [],
      salesDistrictFilter: [],
      bcFilter: [],
      appliedFilters: null,
      multiFilterOptions: {},
      roleDomainOptions: [],
      lastUpdated: null,
    };
  },
  methods: {
    searchDebounce() {
      this.loader = this.$loading.show();
      this.page = 1;
      this.getLookupData();
    },
    getLookupDataWithLoad() {
      this.loader = this.$loading.show();
      this.getLookupData();
    },
    getLookupData() {
      const { search, domainFilter, roleFilter, serviceDistrictFilter, salesDistrictFilter, bcFilter } = this;
      const page = this.page - 1;
      this.$store
        .dispatch('getUserLookup', {
          domainFilter,
          roleFilter,
          page,
          search,
          serviceDistrictFilter,
          salesDistrictFilter,
          bcFilter,
        })
        .then((res) => {
          this.users = res.roles;
          this.totalCount = res.totalCount;
          this.lastUpdated = res.rolesLastUpdated;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          this.loader.hide();
        });
    },
    goToPrograms() {
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$router.push({
        name: 'Programs',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    getFilters() {
      const RoleFilters = [];
      const DomainFilters = this.roleDomainOptions;
      const ServiceDistrictFilters = [];
      const SalesDistrictFilters = [];
      const BCFilters = [];

      this.$store.dispatch('getDistrictFilters').then((res) => {
        res.serviceFilters.forEach((filter) => {
          ServiceDistrictFilters.push({
            label: filter,
            checked: false,
          });
        });
        res.salesFilters.forEach((filter) => {
          SalesDistrictFilters.push({
            label: filter,
            checked: false,
          });
        });
        res.bcFilters.forEach((filter) => {
          BCFilters.push({
            label: filter,
            checked: false,
          });
        });
      });

      this.$store.dispatch('getRoles').then((res) => {
        res.forEach((filter) => {
          RoleFilters.push({
            label: filter.description,
            checked: false,
          });
        });
      });

      this.multiFilterOptions = {
        Domain: DomainFilters,
        Role: RoleFilters,
        ServiceDistrict: ServiceDistrictFilters,
        SalesDistrict: SalesDistrictFilters,
        BC: BCFilters,
      };
      this.createFilters();
    },
    createFilters() {
      this.domainFilter = [];
      this.roleFilter = [];
      this.serviceDistrictFilter = [];
      this.salesDistrictFilter = [];
      this.bcFilter = [];

      this.$store.state.activeLookupFilters = this.multiFilterOptions;
      this.setAppliedFilters();
    },
    setAppliedFilters() {
      this.domainFilter = [];
      this.roleFilter = [];
      this.serviceDistrictFilter = [];
      this.salesDistrictFilter = [];
      this.bcFilter = [];

      const { domainFilter, roleFilter, serviceDistrictFilter, salesDistrictFilter, bcFilter } = this;

      let length = 0;
      if (this.activeFilters) {
        if (this.activeFilters.Role) {
          this.activeFilters.Domain.forEach((option) => {
            if (option.checked) domainFilter.push(option.label);
          });
        }
        if (this.activeFilters.Role) {
          this.activeFilters.Role.forEach((option) => {
            if (option.checked) roleFilter.push(option.label);
          });
        }
        if (this.activeFilters.ServiceDistrict) {
          this.activeFilters.ServiceDistrict.forEach((option) => {
            if (option.checked) serviceDistrictFilter.push(option.label);
          });
        }
        if (this.activeFilters.SalesDistrict) {
          this.activeFilters.SalesDistrict.forEach((option) => {
            if (option.checked) salesDistrictFilter.push(option.label);
          });
        }
        if (this.activeFilters.BC) {
          this.activeFilters.BC.forEach((option) => {
            if (option.checked) bcFilter.push(option.label);
          });
        }
      }
      length =
        domainFilter.length +
        roleFilter.length +
        serviceDistrictFilter.length +
        salesDistrictFilter.length +
        bcFilter.length;

      this.appliedFilters = {
        roleFilter,
        domainFilter,
        serviceDistrictFilter,
        salesDistrictFilter,
        bcFilter,
        length,
      };
    },
    updateMulti(updates) {
      this.loader = this.$loading.show();
      this.page = 1;
      this.multiFilterOptions = updates;
      this.$store.state.activeLookupFilters = this.multiFilterOptions;
      this.setAppliedFilters();
      this.getLookupData();
    },
    clearAllFilters() {
      if (this.multiFilterOptions.Domain) {
        this.multiFilterOptions.Domain.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.Role) {
        this.multiFilterOptions.Role.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.ServiceDistrict) {
        this.multiFilterOptions.ServiceDistrict.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.SalesDistrict) {
        this.multiFilterOptions.SalesDistrict.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.BC) {
        this.multiFilterOptions.BC.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      this.appliedFilters.length = 0;
      this.$store.state.activeLookupFilters = this.multiFilterOptions;
    },
    getDomains() {
      this.$store.dispatch('getDomains').then((res) => {
        const domainOptions = res;
        const tempArray = [];
        domainOptions.forEach((domain) => {
          const tempObj = {
            label: domain.domain,
            checked: false,
          };
          tempArray.push(tempObj);
        });
        this.roleDomainOptions = tempArray.filter(
          (value, index, self) => index === self.findIndex((t) => t.label === value.label),
        );
        this.getFilters();
      });
    },
  },
  computed: {
    ...mapState('global', ['programStyle']),
    ...mapState(['activeNavBar']),
    ...mapState({
      domain: (state) => state.global.programName,
      activeFilters: 'activeLookupFilters',
    }),
    pageCount() {
      if (this.users) {
        const l = this.totalCount;
        const s = this.rowCountDropValue.value;
        return Math.ceil(l / s);
      }
      return null;
    },
    firstRow() {
      if (this.users.length > 0) {
        return (this.page - 1) * 15 + 1;
      }
      return 0;
    },
    lastRow() {
      return (this.page - 1) * 15 + this.users.length;
    },
  },
  watch: {},
  created() {
    this.getDomains();
    this.getLookupData();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    .breadcrumb {
      cursor: pointer;
      margin-right: 5px;
      div {
        margin-left: 5px;
      }
    }
  }
}
.filter-wrapper {
  position: unset;
  ::v-deep {
    .modal-wrapper {
      top: 72px;
      right: 415px;
    }
  }
}

.logo {
  vertical-align: middle;
  width: 400px;
  margin-top: 35px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}

input {
  width: 300px;
}

::placeholder {
  color: black;
  opacity: 1;
}
.placeholder-div {
  width: 130px;
}
.finalization-buttons {
  .button-one {
    margin-right: 20px;
  }
}
.modal-body {
  text-align: left;
  .title {
    text-transform: none;
    text-align: left;
    font-size: 22px;
  }
  input {
    &::placeholder {
      color: #aeaeae;
    }
    width: 96%;
    margin-top: 20px;
    border: 1px solid #dfe4e8;
  }
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  .subtitle {
    color: black;
    font-size: 20px;
    margin-top: 20px;
  }
  .calendar-container {
    margin-top: 10px;
  }
  .button-container {
    margin-top: 20px;
    .finalize {
      margin-right: 20px;
    }
  }
}
.data-table {
  ::v-deep {
    th {
      white-space: normal;
    }
  }
}
.config {
  margin-top: 20px;
}
.last-updated {
  margin: 10px 0;
}
</style>
